import { AddressService } from '@/common/services/address/address.service';
import { replaceByObject } from '@/common/utils/strings/replace.utils';
import { CitiesResponse } from '@/core/domain/address/models/cities-response.model';
import { CountriesResponse } from '@/core/domain/address/models/countries-response.model';
import { NeighborhoodsResponse } from '@/core/domain/address/models/neighborhoods-response.model';
import { StatesResponse } from '@/core/domain/address/models/states-response.model';
import { ZipCodesResponse } from '@/core/domain/address/models/zipcodes-response.model';
import { AddressRepository } from '@/core/domain/address/repositories/address.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AddressImplRepository extends AddressRepository {
    constructor(
        private readonly http: HttpClient,
        private addressService: AddressService,
    ) {
        super();
    }

    override getNeighborhoods(
        cityId: number,
    ): Observable<NeighborhoodsResponse> {
        return this.http
            .get<NeighborhoodsResponse>(
                replaceByObject(
                    [
                        environment.alamoApi.BASE_HOST,
                        environment.alamoApi.ENDPOINTS.neighborhoods,
                    ].join('/'),
                    {
                        cityId: cityId,
                    },
                ),
            )
            .pipe(
                switchMap((response) => {
                    this.addressService.neighborhoods = response.data.suburbs;
                    return of(response);
                }),
            );
    }

    override getCities(stateId: number): Observable<CitiesResponse> {
        return this.http
            .get<CitiesResponse>(
                replaceByObject(
                    [
                        environment.alamoApi.BASE_HOST,
                        environment.alamoApi.ENDPOINTS.cities,
                    ].join('/'),
                    {
                        stateId: stateId,
                    },
                ),
            )
            .pipe(
                switchMap((response) => {
                    this.addressService.cities = response.data.cities;
                    return of(response);
                }),
            );
    }

    override getStates(countryId: number): Observable<StatesResponse> {
        return this.http
            .get<StatesResponse>(
                replaceByObject(
                    [
                        environment.alamoApi.BASE_HOST,
                        environment.alamoApi.ENDPOINTS.states,
                    ].join('/'),
                    {
                        countryId: countryId,
                    },
                ),
            )
            .pipe(
                switchMap((response) => {
                    this.addressService.states = response.data.states;
                    return of(response);
                }),
            );
    }

    override getCountries(): Observable<CountriesResponse> {
        return this.http
            .get<CountriesResponse>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.countries,
                ].join('/'),
            )
            .pipe(
                switchMap((response) => {
                    this.addressService.countries = response.data.countries;
                    return of(response);
                }),
            );
    }
}
